/*global sendGAFyle, sendGAAdlift */

//Sending events to GA using gtag
const sendGaEvents = (eventCategory, eventAction, eventLabel, sendToAdlift) => {
  if (sendGAFyle) {
    sendGAFyle('event', eventAction, {
      'event_category': eventCategory,
      'event_label': eventLabel
    });
    if (sendGAAdlift && sendToAdlift) {
      sendGAAdlift('event', 'conversion', { 'send_to': 'AW-939015491/NYpFCI3iyZYBEMP64L8D' });
    }
  }
};

// Changing GA Event Action for Content Footer Links
const setFooterActionForGA = (headline) => {
  const contentFooterLink = headline.split(' ');
  const contentFooterLinkType = contentFooterLink[0];
  let eventAction;
  if (contentFooterLinkType === '[BLOG]') {
    eventAction = 'blog';
  }
  else if (contentFooterLinkType === '[GUIDE]') {
    eventAction = 'guide';
  }
  else if (contentFooterLinkType === '[FAQ]') {
    eventAction = 'help';
  }
  sendGaEvents('click-internal', eventAction, 'content-footer');
};

// Added capterra script on success of demo form submission
const addCapterraScript = () => {
  const capterravKey = '288d11fab170b44443926cb33274310d',
    capterraVid = '2113289',
    capterraPrefix = (('https:' === document.location.protocol) ? 'https://ct.capterra.com' : 'http://ct.capterra.com');
  {
    const ct = document.createElement('script'); ct.type = 'text/javascript'; ct.async = true;
    ct.src = `${capterraPrefix}/capterra_tracker.js?vid=${capterraVid}&vkey=${capterravKey}`;
    const s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ct, s);
  }
};

window.sendGaEvents = sendGaEvents;
window.setFooterActionForGA = setFooterActionForGA;

export {
  addCapterraScript
};